"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = {
  MuiIcon: {
    fontSizeLarge: {
      fontSize: "1rem"
    },
    fontSizeSmall: {
      fontSize: "0.75rem"
    },
    root: {
      fontSize: "0.875rem",
      overflow: "visible",
      textAlign: "center"
    }
  }
};
exports.default = _default;